<section class="grid" role="region" aria-labelledby="client-details-heading">
	<section class="column" role="region" aria-labelledby="personal-data-heading">
		<h3 id="personal-data-heading">
			<mat-icon class="material-symbols-outlined" aria-hidden="true">person</mat-icon>
			<span>{{ 'base.field.group.personal_data' | transloco }}</span>
		</h3>

		<section class="info-row">
			<div class="name-column">
				<strong>{{ client()?.firstName }}</strong>
				<strong>{{ client()?.name }}</strong>
			</div>
			<section class="data-column">
				<p [attr.aria-label]="'base.field.gender' | transloco">{{ client()?.gender?.salutation }}</p>
				<p [attr.aria-label]="'base.field.date_of_birth' | transloco">
					{{ isValidDate(client()?.dateOfBirth) ? (client()?.dateOfBirth | date: dateDisplayFormat) : '' }}
				</p>
				<p [attr.aria-label]="'base.field.residence_district' | transloco">{{ clientCounty()?.remark }}</p>
			</section>
		</section>

		<h3 id="address-heading">
			<mat-icon class="material-symbols-outlined" aria-hidden="true">home_pin</mat-icon>
			{{ 'base.field.group.address' | transloco }}
		</h3>

		<address>
			<p [attr.aria-label]="'base.field.street_address' | transloco">{{ client()?.address?.streetAndHouseNumber }}</p>
			<p [attr.aria-label]="'base.field.postal_code_and_city' | transloco">
				{{ client()?.address?.postalCodeAndCity }}
			</p>
		</address>
	</section>

	<section class="column" role="region">
		<ng-container *lvrPermission="['Clients.Read', 'Clients.Read.PhaseOneOnly']">
			<h3 id="communication-heading">
				<mat-icon class="material-symbols-outlined" aria-hidden="true">phone_in_talk</mat-icon>
				<span>{{ 'institution.details.communication' | transloco }}</span>
			</h3>

			<section class="communication" aria-labelledby="communication-heading">
				@if (preferredCommunicationWay()) {
					<p class="label communication-group-title">{{ 'institution.details.preferred_communication' | transloco }}</p>
					<p class="label">{{ getCommunicationTypeLabel(preferredCommunicationWay()!.categoryContactPointId) }}</p>
					@if (isPhoneType(preferredCommunicationWay()!.categoryContactPointId)) {
						<p>
							<a [href]="'tel:' + preferredCommunicationWay()!.contactValue">
								{{ preferredCommunicationWay()!.contactValue }}
							</a>
						</p>
					} @else if (isEmailType(preferredCommunicationWay()!.categoryContactPointId)) {
						<p>
							<a [href]="'mailto:' + preferredCommunicationWay()!.contactValue">
								{{ preferredCommunicationWay()!.contactValue }}
							</a>
						</p>
					} @else {
						<p>{{ preferredCommunicationWay()!.contactValue }}</p>
					}
					<p>{{ preferredCommunicationWay()!.remark }}</p>
				}
				<!-- Additional communication ways -->
				@if (communicationWays().length >= 1) {
					<p style="padding-top: 10px" class="label communication-group-title">
						{{ 'institution.details.other_communication' | transloco }}
					</p>
					<section role="region">
						@for (cp of communicationWays(); track cp.id) {
							<div lvrBorder borderPosition="bottom" lvrPadding [padHorizontal]="8" [padVertical]="0">
								<p class="label">{{ getCommunicationTypeLabel(cp.categoryContactPointId) }}</p>
								@if (isPhoneType(cp.categoryContactPointId)) {
									<p>
										<a [href]="'tel:' + cp.contactValue">
											{{ cp.contactValue }}
										</a>
									</p>
								} @else if (isEmailType(cp.categoryContactPointId)) {
									<p>
										<a [href]="'mailto:' + cp.contactValue">
											{{ cp.contactValue }}
										</a>
									</p>
								} @else {
									<p>{{ cp.contactValue }}</p>
								}
								@if (shouldShowRemark(cp.remark, cp.categoryContactPointId)) {
									<p style="margin-top: 16px">{{ cp.remark }}</p>
								}
							</div>
						}
					</section>
				}
			</section>
		</ng-container>
	</section>
</section>
